import { render, staticRenderFns } from "./MsListItem.vue?vue&type=template&id=e50e62f6&scoped=true&"
import script from "./MsListItem.vue?vue&type=script&lang=js&"
export * from "./MsListItem.vue?vue&type=script&lang=js&"
import style0 from "./MsListItem.vue?vue&type=style&index=0&id=e50e62f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50e62f6",
  null
  
)

export default component.exports